import styled from "styled-components";

export const SectionContainer = styled.section`
	.body-container {
		.donation-settings {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 2rem;

			span {
				font-size: 0.8rem;

				&:first-child {
					margin-right: 0.4rem;
				}
			}

			.custom-control-input:checked ~ .custom-control-label::before {
				border-color: #4cd964 !important;
				background-color: #4cd964 !important;
			}
		}

		.donation,
		.designation,
		.billing-address {
			margin-bottom: 1.5rem;

			.heading {
				font-size: 1rem;
				line-height: normal;
			}

			.description {
				color: #4a4a4a;
			}

			form {
				.input-container {
					width: 100%;
					margin-bottom: 1rem;

					&:last-child {
						margin-bottom: 0;
					}

					label {
						display: block;
						color: #4a4a4a;
						font-size: 0.8rem;
						text-transform: capitalize;
					}

					input,
					select,
					textarea {
						width: 100%;
						border-radius: 8px;
						outline: none;
						border: 1px solid rgba(0, 0, 0, 0.2);
					}

					input,
					select {
						height: 40px;
					}

					select {
						padding: 0 10px;
						background: transparent !important;

						option {
							color: #4a4a4a !important;
						}
					}

					textarea {
						height: 103px;
					}
				}
			}
		}

		.donation {
			.donation-amounts {
				width: 100%;
				margin-bottom: 1.5rem;

				button {
					background: #ffffff;
					border: 1px solid rgba(0, 0, 0, 0.2);
					border-radius: 8px;

					&.selected {
						background: #e5edf6;
					}
				}
			}
		}

		.billing-address {
			margin-bottom: 0;
		}

		@media (min-width: 768px) {
			.donation-settings {
				margin-bottom: 60px;

				span {
					font-size: 1rem;
				}
			}

			.donation,
			.designation,
			.billing-address {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				margin-bottom: 80px;

				.details-container {
					width: 310px;

					.heading {
						margin-bottom: 18px;
						font-size: 2rem;
						line-height: normal;
					}

					.description {
						font-size: 1rem;
					}
				}

				form {
					width: 533px;

					.input-container {
						margin-bottom: 33px;

						&:last-child {
							margin-bottom: 0;
						}

						label {
							font-size: 1rem;
						}

						input,
						textarea {
							width: 100%;
						}
					}
				}
			}

			.donation {
				.donation-amounts {
					width: 533px;

					button {
						margin-right: 16px;
						padding: 7px 10px;
					}
				}
			}

			.billing-address {
				margin-bottom: 0;

				form {
					display: grid;
					grid-template-columns: repeat(2, 1fr);
					column-gap: 48px;
				}
			}
		}

		.button-container {
			display: flex;
			justify-content: center;
			margin-top: 1rem;

			button {
				padding: 1rem 1.8rem;
				margin: auto;
				border: 0.7px solid #024ca3;
				background-color: #024ca3;
				color: white;
				font-size: 0.9rem;
				font-weight: 500;
				text-transform: uppercase;
				cursor: pointer;

				@media (max-width: 768px) {
					padding: ${(props) =>
						props.wide ? "0.8rem 1.9rem" : "0.8rem 1.6rem"};
					font-size: 0.8rem;
				}
			}
		}
	}
`;
